import { ReactElement } from "react";
import { IWeatherData } from "../../../../../services/http/weatherdata/models/IWeatherData";
import weatherIcons from "../../../../../shared/weatherIcons";
import styles from '../Weather.module.scss';

const MainInfo = (props: IWeatherData): ReactElement =>
{
    const getWeatherIcon = () =>
    {
        const iconKey = Object.keys(weatherIcons).find(x => x.toLowerCase() === props.conditionType.toLowerCase());
        return iconKey ? weatherIcons[iconKey] : null;
    }

    return (
        <div className={styles.mainInfo}>
            <span>{props.temperature.toFixed(0)}ºF</span>
            {getWeatherIcon()}
        </div>
    );
}

export default MainInfo;